import { useMe as libUseMe, useLogout as libUseLogout } from "@marekl/adminer";
import type { Datified, Schemas } from "../api/types";

export type Role = "user" | "admin";

/** Session user from GET /api/auth/me. */
export type User = Datified<Schemas["User"], "created_at">;

/** Fetches the currently authenticated user. Returns null if not logged in. */
export function useMe() {
  return libUseMe<User>();
}

/** Logs out and clears all cached query data. */
export function useLogout() {
  return libUseLogout();
}
